/**
 * Post and return res.data, or false on failure.
 */
export async function postAndReturnData(url, data, config = {}) {
    try {
        const res = await axios.post(url, data, config);
        return res.data;
    } catch {
        return false;
    }
}

/**
 * Post and return res.data only when res.data.status is truthy, or 'fail' on error.
 * Used by the form API functions (quiz, login, account, etc.).
 */
export async function postWithStatusCheck(url, data, config = {}) {
    try {
        const res = await axios.post(url, data, config);
        if (res.data.status) {
            return res.data;
        }
    } catch (err) {
        console.log(err);
        return 'fail';
    }
}
